import {inject, injectable} from 'inversify';

import type {MembershipModel} from '../../../core/domain/Membership/Membership.model';
import type {Nullable} from '../../../utils/utility-types';

import {FetchMembershipListQuery} from '../../../core/ports/Membership/FetchMembershipList/FetchMembershipList.query';
import {EnvProviderService} from '../../../core/system/env/EnvProvider.service';
import {logger} from '../../../utils/logger';

@injectable()
export class FetchLastMembershipUseCase {
  constructor(
    @inject(FetchMembershipListQuery)
    private readonly query: FetchMembershipListQuery,
    @inject(EnvProviderService) private readonly env: EnvProviderService,
  ) {}

  async exec({
    courseId,
    userId,
  }: FetchLastMembershipUseCase.Props): Promise<FetchLastMembershipUseCase.Response> {
    try {
      const excludedStatuses = [
        'proposed',
        'requested',
        this.env.app.isCore ? 'declined' : null,
      ].filter(Boolean) as MembershipModel.Status[];

      const [target] = await this.query.exec({
        courseId,
        excludedStatuses,
        userId,
      });

      if (!target) {
        return null;
      }

      return target;
    } catch (e) {
      logger.error(e);

      throw e;
    }
  }
}

export namespace FetchLastMembershipUseCase {
  export type Props = {
    courseId: string;
    userId: string;
  };

  export type Response = Nullable<MembershipModel>;
}
